import Vue from 'vue'

export const focusOn = function (id) {
  Vue.nextTick(function () {
    $('#' + id).focus()
  })
}

// Takes a html element as argument
export const isVisibleOnScreen = function (elm) {
  const rect = elm.getBoundingClientRect()
  const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight)
  return !(rect.bottom < 15 || rect.top - viewHeight >= -45)
}

export const getRecaptchaToken = async function (isRecaptchaActive, recaptchaSiteKey, action) {
  if (!isRecaptchaActive || isRecaptchaActive === false) return 'disabled'

  const recaptchaToken = await window.grecaptcha.enterprise.execute(recaptchaSiteKey, { action: action })
  console.debug(`Recaptcha token: ${recaptchaToken}`)
  return recaptchaToken
}
